<template>
  <div id="hero" class="hero-wrap bg-f hero-bg-14 style4">
    <div class="container">
      <div class="row gx-5 align-items-end">
        <div class="col-lg-6">
          <div class="hero-content">
            <span
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              Do Your Health Checkup
            </span>
            <h1
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              The Greatest Part Of Your Life Is Health
            </h1>
            <p data-aos="fade-up" data-aos-duration="1200" data-aos-delay="400">
              Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus
              hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet
              vel dapibus id dolor sit amet.
            </p>
            <div
              class="hero-btn"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="500"
            >
              <a href="#appointment" class="btn style2">Book An Appointment</a>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="hero-img-wrap">
            <img src="../../assets/images/hero/hero-img-15.png" alt="Image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>